import { render } from "./RatingInput.vue?vue&type=template&id=3cc22f0d"
import script from "./RatingInput.vue?vue&type=script&lang=js"
export * from "./RatingInput.vue?vue&type=script&lang=js"

import "./RatingInput.vue?vue&type=style&index=0&id=3cc22f0d&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__